module.exports = __webpack_public_path__ + "static/media/carBreakdown.592de83b.svg";